import React from 'react';
import { withLocalize } from "react-localize-redux";
import SearchInput from 'react-search-input';


import ContainerTranslation from "../partials/ContainerTranslation";
import Select from 'react-select';
import _ from 'lodash';
import { SliderCheckbox } from '../input/Checkbox';
import { RangeSlider } from '../input/Slider';
import Popup from '../partials/SelectDocPopup';
// import { deleteData } from '../../actions';

var common = require('../../assets/translations/common.json');

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center',
};






const formatGroupLabel = data => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
);
//TODO react select 2.0.0
class ConsultantSearch extends React.Component {

  constructor(props) {
    super(props);
    this.user = JSON.parse(localStorage.getItem("user"));
    this.state = {
      isExtractPopupOpen: false,
      isButtonDisabled: false,
    };
  }

  selectItem = (parent, names,  data  ) => {
      var _this = this

    if(Array.isArray(data)){
        var dataToReturn = []


        if (names) {
            _.each(names, function (name) {
                dataToReturn.push({
                    index: null,
                    name: name,
                    parent: parent,
                    value: [],
                });
            })
        } 
        else {
            dataToReturn.push({
              index: null,
              name: null,
              parent: parent,
              value: [],
            });
      }

      _.each(data, function(d){

        var foundData = _.find(dataToReturn, function(dr){
          if(d.name){
            return dr.name === d.name && dr.parent === d.parent
          }else{
            return dr.parent === d.parent
          }
        })

        if(foundData){
          foundData.value.push(d.value)
        }else{
          dataToReturn.push({
              index: undefined,
              name: d.name,
              parent: d.parent,
              value: [d.value],
              filter: d.filter
          })
        }
      })
        _.each(dataToReturn, function (d) {
        _this.props.selectItem(d);
      })
    } else{
      _this.props.selectItem(data);
    }
  }


  toggleExtractPopup() {
		this.setState({ isExtractPopupOpen: !this.state.isExtractPopupOpen });
	}

  handleSortChange(data) {
    this.props.setSort(data.value);
  }

  handleValidationFilter(data) {
    this.props.selectValidationFilter(data.value);
  }

  handleExpertiseFilter(field, value) {
    this.props.setExpertiseFilter(field, value);
  }



  getExpertiseLevel(expertiseFilter,competencyGroup="general"){
      const sliderValue = {
          "general": ['basic', 'limited', 'intermediate', 'advanced', 'expert'],
          "certification-body": ["signatory under mentorship", "assessor under mentorship", "signatory", "assessor", "lead assessor"],
          "inspection-body": ["assessor under mentorship", "assessor", "lead assessor/technical manager"],
          "non-accredited-services": ["technical manager", "signatory", "assessor", "lead assessor"]
      };
    const result = expertiseFilter.map((filter)=>{return sliderValue[competencyGroup].findIndex((value)=>value === filter)})

    return [Math.min(...result),Math.max(...result)]

  }




  render() {
    

      const sliderOption = [
          { value: 0, label: 'basic' },
          { value: 1, label: 'limited' },
          { value: 2, label: 'intermediate' },
          { value: 3, label: 'advanced' },
          { value: 4, label: 'expert' },
      ];

      const certificationBodySliderOptions = [
          { value: 0, label: 'signatory under\n mentorship' },
          { value: 1, label: 'assessor under\n mentorship' },
          { value: 2, label: 'signatory' },
          { value: 3, label: 'assessor' },
          { value: 4, label: 'lead assessor' },
      ];

      const inspectionBodySliderOptions = [
          { value: 0, label: 'assessor under\n mentorship' },
          { value: 1, label: 'assessor' },
          { value: 2, label: 'lead assessor\ntechnical manager' },
      ];

      const nonAccreditedServicesSliderOptions = [
          { value: 0, label: 'technical\n manager' },
          { value: 1, label: 'signatory' },
          { value: 2, label: 'assessor' },
          { value: 3, label: 'lead assessor' },
      ];

    var _this = this
    var type;
    var initConsultants = _.cloneDeep(this.props.initConsultants);
    var consultantList = [];

    var informationOptions = [];
    var informationData = ['filiale-country', 'office', 'manager'];
    let informationDefaultValue = []
    if(this.props.consultants){
      type = 'information-consultant';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants;
      };
      _.each(informationData, function(data) {
        informationOptions.push({
          label: _this.props.translate("Filters-labels."+ [common.content[type][data].title[0]]),
          options: _.compact(_.uniqBy(_.compact(_.map(consultantList, function(consultant){
            if(consultant.content && consultant.content[type] && consultant.content[type][data]){
              return {
                value : consultant.content[type][data],
                label : consultant.content[type][data],
                name : data,
                parent : type,
              }
            }
          })),'value'))
        })
        _.forEach(_this.props.selectedItems[type][data], function(option){
          
          informationDefaultValue.push({
            value : option,
            label : option,
            name : data,
            parent : type
          })
        })
      })
    };

    var schoolOptions = []
    var schoolData = ['school-name', 'school-year', 'school-diplome']
    let schoolDefaultValue = []
    if(this.props.consultants){
      type = 'school';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(schoolData, function(data){
        var options = []
        _.each(consultantList, function(consultant){
          _.each(consultant.content[type], function(item){
              options.push(item[data])
          })
        })

        schoolOptions.push({
          label: _this.props.translate("Filters-labels."+ [common.content[type][data].title[0]]),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option){
              return {
                value : option,
                label : option,
                name : data,
                parent : type,
              }
            }
          })),'value'))
        })

        _.forEach(_this.props.selectedItems[type][data], function(option){
          
          schoolDefaultValue.push({
            value : option,
            label : option,
            name : data,
            parent : type
          })
        })
      })
    }

    var languageOptions = []
    var languageData = ['language-name', 'language-test', 'language-result']
    let languageDefaultValue = []
    if(this.props.consultants){
      type = 'language'
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(languageData, function(data){
        var options = []
        _.each(consultantList, function(consultant){
          _.each(consultant.content[type], function(item){
            if (item) {
              options.push(item[data])
            }
          })
        })

        languageOptions.push({
          label: _this.props.translate("Filters-labels."+ [common.content[type][data].title[0]]),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option){
              return {
                value : option,
                label : option,
                name : data,
                parent : type
              }
            }
          })),'value'))
        })

        _.forEach(_this.props.selectedItems[type][data], function(option){
          
          languageDefaultValue.push({
            value : option,
            label : option,
            name : data,
            parent : type
          })
        })

      })

      



    }



    var formationOptions = []
    var formationData = ['formation-name']
    let formationDefaultValue = []
    if(this.props.consultants){
      type = 'formation';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(formationData, function(data){
        var options = []
        _.each(consultantList, function(consultant){
          _.each(consultant.content[type], function(item){
            options.push(item[data])
          })
        })

        formationOptions.push({
          label: _this.props.translate("Filters-labels."+ [common.content[type][data].title[0]]),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option){
              return {
                value : option,
                label : option,
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
        _.forEach(_this.props.selectedItems[type][data], function(option){
          
          formationDefaultValue.push({
            value : option,
            label : option,
            name : data,
            parent : type
          })
        })
      })
    }

    var certificationOptions = []
    var certificationData = ['certification-name', 'certification-organisme']
    let certificationDefaultValue = []
    if(this.props.consultants){
      type = 'certification';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(certificationData, function(data){
        var options = []
        _.each(consultantList, function(consultant){
          _.each(consultant.content[type], function(item){
            options.push(item[data])
          })
        })

        certificationOptions.push({
          label: _this.props.translate("Filters-labels."+ [common.content[type][data].title[0]]),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option){
              return {
                value : option,
                label : option,
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
        _.forEach(_this.props.selectedItems[type][data], function(option){
          certificationDefaultValue.push({
            value : option,
            label : option,
            name : data,
            parent : type
          })
        })
      })
    }

    var environnementOptions = []
    var environnementData = ['environnement-domain', 'environnement-context']
    let environnementDefaultValue = []
    if(this.props.consultants){
      type = 'environnement';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(environnementData, function(data){
        let options = []
        _.each(consultantList, function(consultant){
          if(consultant && consultant.content){
            let domain = Object.keys(consultant.content.environnement[data])
            if(data==="environnement-context"){
              domain.forEach((names) => {
                let context = Object.keys(consultant.content.environnement[data][names])
                context.forEach((name) => {
                  options.push(name)
                })
              });
            } else {
              domain.forEach((name) => {
                options.push(name)
              });
            }
          }
        })

        environnementOptions.push({
          label: _this.props.translate("Filters-labels."+ [common.content[type][data].title[0]]),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option){
              return {
                value : option,
                label : _this.props.translate(['context'] +"." + [option]),
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
        _.forEach(_this.props.selectedItems[type][data], function(option){
          environnementDefaultValue.push({
            value : option,
            label : _this.props.translate(['context'] +"." + [option]),
            name : data,
            parent : type
          })
        })
      })
    }

    var expertiseOptions = []
    var expertiseData = ['domain-competence', 'domain-speciality', 'domain-specificity']
    let expertiseDefaultValue = []
    if(this.props.consultants){
      type = 'expertise';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(expertiseData, function(data){
        var options = []
        var category = common.content[type][data].title[0]
        _.each(consultantList, function(consultant){
          _.each(consultant.content[type], function(item){
            var obj = item
            obj.name  = item[data]
            if (category === "Technical competence") {
              obj.label = _this.props.translate(['domain-competence'] +"." + item['domain-competence'])
            }
            if (category === "Technical specialty") {
              obj.label = _this.props.translate(['domain-speciality'] +"." + item['domain-competence']+"." + item['domain-speciality'])
            }
            if (category === "Technical specificity") {
              obj.label = _this.props.translate(['domain-specificity'] +"." + item['domain-speciality'] +"." + item['domain-specificity'])
            }
            options.push(obj)
          })
        })

        expertiseOptions.push({
          label: _this.props.translate(['domain-label'] +"." + [category]),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option.name){
              return {
                value : option.name,
                label : option.label ? option.label : option.name,
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
        _.forEach(_this.props.selectedItems[type][data], function(option){
          expertiseDefaultValue.push({
            value : option,
            label : option.label ? option.label : option,
            name : data,
            parent : type
          })
        })
      })
    }

    var interventionLevelOptions = []
    var interventionLevelData = ['intervention-type', 'intervention-mission', 'intervention-application']
    let interventionLevelDefaultValue = []
    if(this.props.consultants){
      type = 'intervention-level';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(interventionLevelData, function(data){
        var options = []
        var category  = common.content[type][data].title[0]
        _.each(consultantList, function(consultant){

          _.each(consultant.content[type], function(item){
            var obj = item
            obj.name  = item[data]
            if (category === "Skill") {
              obj.label = _this.props.translate(['intervention-type'] +"." + item['intervention-type'])
            }
            if (category === "Mission") {
              obj.label = _this.props.translate(['intervention-mission'] +"." + item['intervention-type']+"." + item['intervention-mission'])
            }
            if (category === "Application") {
              obj.label = _this.props.translate(['intervention-application'] +"." + item['intervention-mission'] +"." + item['intervention-application'])
            }
            options.push(obj)
          })
        })
        interventionLevelOptions.push({
          label: _this.props.translate(['intervention-label']+ "." + category),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){

            if(option.name){
              return {
                value : option.name,
                label : option.label ? option.label : option.name,
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
        _.forEach(_this.props.selectedItems[type][data], function(option){
          interventionLevelDefaultValue.push({
            value : option,
            label : option.label ? option.label : option,
            name : data,
            parent : type
          })
        })
      })
    }

    var engineeringOptions = []
    var engineeringData = ['engineering-skill', 'engineering-specialization' ]
    let engineeringDefaultValue = []
    if(this.props.consultants) {
      type = 'engineering';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(engineeringData, function(data){
        var options = []
        var category  = common.content[type][data].title[0];
        _.each(consultantList, function(consultant){
          _.each(consultant.content[type], function(item){
            var obj = item
            obj.name  = item[data];
            if (category === "Skill") {
              obj.label = _this.props.translate(['engineering-skill'] +"." + item['engineering-skill'])
            }
            if (category === "Engineering specialization") {
              obj.label = _this.props.translate(['engineering-specialization'] +"." + item['engineering-skill'] +"." + item['engineering-specialization'])
            }
            options.push(obj)
          })
        })
        engineeringOptions.push({
          label: _this.props.translate("content.engineering." + [data] + ".title") ,
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option.name){
              return {
                value : option.name,
                label : option.label ? option.label : option.name,
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
        _.forEach(_this.props.selectedItems[type][data], function(option){
          engineeringDefaultValue.push({
            value : option,
            label : option.label ? option.label : option,
            name : data,
            parent : type
          })
        })
      })
    }

    var toolOptions = []
    var toolData = ['name']
    let toolDefaultValue = []

    if(this.props.consultants) {
      type = 'tools';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(toolData, function(data){
        var options = []
        _.each(consultantList, function(consultant){
          _.each(consultant.content[type], function(item){
            var obj = item
            if(item[data]){
              obj.name  = item[data];
              options.push(obj)
            }
          })
        })
        toolOptions.push({
          label: _this.props.translate("Filters-labels."+ [common.content[type]['tool'].title[0]]),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option.name){
              return {
                value : option.name,
                label : option.name,
                name : null,
                parent : type
              }
            }
          })),'value'))
        })
        _.forEach(_this.props.selectedItems[type][data], function(option){
          toolDefaultValue.push({
            value : option,
            label : option,
            name : null,
            parent : type
          })
        })
      })
    }


  
    var clientOptions = []
    let clientDefaultValue = []
    if(this.props.consultants){
      type = 'clients';
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      var options = []
      _.each(consultantList, function(consultant){
        _.each(consultant[type], function(type){
          options.push(type)
        })
      })

      clientOptions.push({
        options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
          if(option){
            return {
              value : option,
              label : option,
              name : null,
              parent : type
            }
          }
        })),'value'))
      })
      _.forEach(_this.props.selectedItems[type], function(option){
        clientDefaultValue.push({
          value : option,
          label : option,
          name : null,
          parent : type
        })
      })

    }


      let certificationBodyOptions = []
      let certificationBodyData = ['level-2', 'level-3', 'level-4']
      let certificationBodyDefaultValue = []

      let inspectionBodyOptions = []
      let inspectionBodyData = ['level-2', 'level-3', 'level-4']
      let inspectionBodyDefaultValue = []

      let nonAccreditedServicesOptions = []
      let nonAccreditedServicesData = ['level-2', 'level-3', 'level-4']
      let nonAccreditedServicesDefaultValue = []

      if (this.user.group === "aegis") {


          if (this.props.consultants) {
              type = 'accreditation-body';
              consultantList = _this.props.consultants
              if (this.props.filtersByOr.find(item => item === type)) {
                  consultantList = initConsultants
              };
              _.each(certificationBodyData, function (data) {
                  let options = []
                  let category = data
                  _.each(consultantList, function (consultant) {
                      _.each(consultant.content[type].filter((x) => x['level-1'] === "Certification Body"), function (item) {
                          const obj = item
                          obj.name = item[data]
                          options.push(obj)
                      })
                  })

                  certificationBodyOptions.push({
                      label: _this.props.translate(['domain-label'] + "." + [category]),
                      options: _.compact(_.uniqBy(_.compact(_.map(options, function (option) {
                          if (option.name) {
                              return {
                                  value: option.name,
                                  label: option.label ? option.label : option.name,
                                  name: data,
                                  parent: type,
                                  filter: 'certification-body'
                              }
                          }
                      })), 'value'))
                  })
                  _.forEach(_this.props.selectedItems['certification-body'][data], function (option) {
                      certificationBodyDefaultValue.push({
                          value: option,
                          label: option.label ? option.label : option,
                          name: data,
                          parent: type,
                          filter: 'certification-body'
                      })
                  })
              })
          }


          if (this.props.consultants) {
              type = 'accreditation-body';
              consultantList = _this.props.consultants
              if (this.props.filtersByOr.find(item => item === type)) {
                  consultantList = initConsultants
              };
              _.each(inspectionBodyData, function (data) {
                  let options = []
                  let category = data
                  _.each(consultantList, function (consultant) {
                      _.each(consultant.content[type].filter((x) => x['level-1'] === "Inspection Body"), function (item) {
                          const obj = item
                          obj.name = item[data]
                          options.push(obj)
                      })
                  })

                  inspectionBodyOptions.push({
                      label: _this.props.translate(['domain-label'] + "." + [category]),
                      options: _.compact(_.uniqBy(_.compact(_.map(options, function (option) {
                          if (option.name) {
                              return {
                                  value: option.name,
                                  label: option.label ? option.label : option.name,
                                  name: data,
                                  parent: type,
                                  filter: 'inspection-body'
                              }
                          }
                      })), 'value'))
                  })
                  _.forEach(_this.props.selectedItems['inspection-body'][data], function (option) {
                      inspectionBodyDefaultValue.push({
                          value: option,
                          label: option.label ? option.label : option,
                          name: data,
                          parent: type,
                          filter: 'inspection-body'
                      })
                  })
              })
          }



          if (this.props.consultants) {
              type = 'accreditation-body';
              consultantList = _this.props.consultants
              if (this.props.filtersByOr.find(item => item === type)) {
                  consultantList = initConsultants
              };
              _.each(nonAccreditedServicesData, function (data) {
                  let options = []
                  let category = data
                  _.each(consultantList, function (consultant) {
                      _.each(consultant.content[type].filter((x) => x['level-1'] === "Non-accredited-services"), function (item) {
                          const obj = item
                          obj.name = item[data]
                          options.push(obj)
                      })
                  })

                  nonAccreditedServicesOptions.push({
                      label: _this.props.translate(['domain-label'] + "." + [category]),
                      options: _.compact(_.uniqBy(_.compact(_.map(options, function (option) {
                          if (option.name) {
                              return {
                                  value: option.name,
                                  label: option.label ? option.label : option.name,
                                  name: data,
                                  parent: type,
                                  filter: 'non-accredited-services'
                              }
                          }
                      })), 'value'))
                  })
                  _.forEach(_this.props.selectedItems["non-accredited-services"][data], function (option) {
                      nonAccreditedServicesDefaultValue.push({
                          value: option,
                          label: option.label ? option.label : option,
                          name: data,
                          parent: type,
                          filter: 'non-accredited-services'
                      })
                  })
              })
          }

      }

    const buttonStyle = {
      width: "156px",
      height: "72px",
      marginTop: "20px",
      backgroundColor: this.state.isButtonDisabled ? "#D3D3D3" : "",
    };

    return (
      <div className="formulaires">
        <div className="formulaire-section" style={{width:'100%'}}>

          <div className="formulaire-header">
            <h2><ContainerTranslation id={'Filters'} /></h2><p className="info"><ContainerTranslation id={'Page.Consultant.Filters-info'} /></p>
          </div>

          <div className={"formulaire wide"} style={{padding:"0px"}}>
            <div className={"formulaire-field select"}>
              {/*INFORMATIONS*/}
              <div className={"inline"} style={{width:'calc(33.33% - 20px)'}}>
                <div className="input-container">
                  <label>
                    <ContainerTranslation id={"content."+['information-consultant']+".title"} tag={"span"}/>
                  </label>
                  <div className="switch-container">
                    <label className="switch" htmlFor="information-consultant">
                      <input
                        type="checkbox"
                        id="information-consultant"
                        name="information-consultant"
                        onChange={() => this.props.setFilterByOr("information-consultant")}
                        checked={this.props.filtersByOr.find(item => item === "information-consultant") ? true : false }/>
                      <div className="slider round"></div>
                    </label>
                    {this.props.filtersByOr.find(item => item === "information-consultant") ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                  </div>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    options={informationOptions}
                    isClearable={true}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'information-consultant', informationData )}
                    defaultValue={informationDefaultValue}
                  />
                </div>
              </div>

              {/*SCHOOL*/}
              <div className={"inline"} style={{width:'calc(33.33% - 20px)',marginLeft:'25px'}}>
                <label>
                  <ContainerTranslation id={"content."+['school']+".title"} tag={"span"}/>
                </label>
                <div className="switch-container">
                  <label className="switch" htmlFor="school">
                    <input
                      type="checkbox"
                      id="school"
                      name="school"
                      onChange={() => this.props.setFilterByOr("school")}
                      checked={this.props.filtersByOr.find(item => item === "school") ? true : false }/>
                    <div className="slider round"></div>
                  </label>
                  {this.props.filtersByOr.find(item => item === "school") ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                </div>
                <Select
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  className={'react-select-container'}
                  classNamePrefix="react-select"
                  options={schoolOptions}
                  isClearable={true}
                  formatGroupLabel={formatGroupLabel}
                  isMulti={true}
                  placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                  onChange={this.selectItem.bind(this, 'school', schoolData)}
                  defaultValue={schoolDefaultValue}
                />
              </div>

              {/*LANGUAGES*/}
              <div className={"inline"} style={{width:'calc(33.33% - 20px)',marginLeft:'25px'}}>
                <label>
                  <ContainerTranslation id={"content."+['language']+".title"} tag={"span"}/>
                </label>
                <div className="switch-container">
                  <label className="switch" htmlFor='language'>
                    <input
                      type="checkbox"
                      id='language'
                      name='language'
                      onChange={() => this.props.setFilterByOr('language')}
                      checked={this.props.filtersByOr.find(item => item === 'language') ? true : false }/>
                    <div className="slider round"></div>
                  </label>
                  {this.props.filtersByOr.find(item => item === 'language') ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                </div>
                <Select
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  className={'react-select-container'}
                  classNamePrefix="react-select"
                  options={languageOptions}
                  isClearable={true}
                  formatGroupLabel={formatGroupLabel}
                  isMulti={true}
                  placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                  onChange={this.selectItem.bind(this, 'language', languageData)}
                  defaultValue={languageDefaultValue}
                />
              </div>
            </div>

            <div className={"formulaire-field select"}>
              {/*FORMATION*/}
              <div className={"inline"} style={{width:'calc(33.33% - 20px)'}}>
                <div className="input-container">
                  <label>
                    <ContainerTranslation id={"content."+['formation']+".title"} tag={"span"}/>
                  </label>
                  <div className="switch-container">
                    <label className="switch" htmlFor="formation">
                      <input
                        type="checkbox"
                        id="formation"
                        name="formation"
                        onChange={() => this.props.setFilterByOr("formation")}
                        checked={this.props.filtersByOr.find(item => item === "formation") ? true : false }/>
                      <div className="slider round"></div>
                    </label>
                    {this.props.filtersByOr.find(item => item === "formation") ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                  </div>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    isClearable={true}
                    options={formationOptions}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'formation', formationData)}
                    defaultValue={formationDefaultValue}
                  />
                </div>
              </div>


              {/*CERTIFICATION*/}
              <div className={"inline"} style={{width:'calc(33.33% - 20px)',marginLeft:'25px'}}>
                <div className="input-container">
                  <label>
                    <ContainerTranslation id={"content."+['certification']+".title"} tag={"span"}/>
                  </label>
                  <div className="switch-container">
                    <label className="switch" htmlFor="certification">
                      <input
                        type="checkbox"
                        id="certification"
                        name="certification"
                        onChange={() => this.props.setFilterByOr("certification")}
                        checked={this.props.filtersByOr.find(item => item === "certification") ? true : false }/>
                      <div className="slider round"></div>
                    </label>
                    {this.props.filtersByOr.find(item => item === "certification") ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                  </div>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    options={certificationOptions}
                    isClearable={true}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'certification', certificationData)}
                    defaultValue={certificationDefaultValue}
                  />
                </div>
              </div>

              {/*CLIENTS*/}
              <div className={"inline"} style={{width:'calc(33.33% - 20px)', marginLeft:'25px'}}>
                <div className="input-container">
                  <label>
                    clients
                  </label>
                  <div className="switch-container">
                    <label className="switch" htmlFor="tools">
                      <input
                        type="checkbox"
                        id="clients"
                        name="clients"
                        onChange={() => this.props.setFilterByOr("clients")}
                        checked={this.props.filtersByOr.find(item => item === "clients") ? true : false }/>
                      <div className="slider round"></div>
                    </label>
                    {this.props.filtersByOr.find(item => item === "clients") ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                  </div>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    options={clientOptions}
                    isClearable={true}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'clients', null)}
                    defaultValue={clientDefaultValue}
                  />
                </div>
              </div>

            </div>

            <div className={"formulaire-field select"}>
              

              {/*INTERVENTION LEVEL*/}
              <div className={"inline"} style={{width:'calc(33.33% - 20px)'}}>
                <div className="input-container">
                  <div>
                    <span >
                      <ContainerTranslation id={"content."+['intervention-level']+".title"} tag={"span"}/>
                    </span>
                    <SliderCheckbox
                      style={{display:"inline-block",float:"right",height:"auto"}}
                      label={this.props.filtersByOr.find(item => item === 'intervention-level') ? 
                        this.props.translate('Filters-labels.' + ['add-to-select']) : 
                        this.props.translate('Filters-labels.' + ['combine-to-select'])}
                      onClick={() => this.props.setFilterByOr('intervention-level')}
                      checked={this.props.filtersByOr.find(item => item === 'intervention-level') ? true : false }
                    />
                  </div>
                  <RangeSlider 
                    sliderOption={sliderOption}             
                    value={this.getExpertiseLevel(this.props.expertiseFilter['intervention-level'])}
                    onChangeEnd={this.handleExpertiseFilter.bind(this,'intervention-level')}
                  />
                  <Select
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    options={interventionLevelOptions}
                    isClearable={true}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'intervention-level', interventionLevelData)}
                    defaultValue={interventionLevelDefaultValue}
                  />
                </div>
              </div>


              {/*ENVIRONNEMENT*/}
              <div className={"inline"} style={{width:'calc(33.33% - 20px)', marginLeft:'25px'}}>
                <div className="input-container">
                  <label>
                    <ContainerTranslation id={"content."+['environnement']+".title"} tag={"span"}/>
                  </label>
                  <div className="switch-container">
                    <label className="switch" htmlFor="environnement">
                      <input
                        type="checkbox"
                        id="environnement"
                        name="environnement"
                        onChange={() => this.props.setFilterByOr("environnement")}
                        checked={this.props.filtersByOr.find(item => item === "environnement") ? true : false }/>
                      <div className="slider round"></div>
                    </label>
                    {this.props.filtersByOr.find(item => item === "environnement") ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                  </div>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    options={environnementOptions}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'environnement', environnementData)}
                    defaultValue={environnementDefaultValue}
                  />
                </div>
              </div>


              {/*EXPERTISE*/}
              <div className={"inline"} style={{width:'calc(33.33% - 20px)', marginLeft:'25px'}}>
                <div className="input-container">
                  <div>
                    <span >
                      <ContainerTranslation id={"content."+['expertise']+".title"} tag={"span"}/>
                    </span>
                    <SliderCheckbox
                      style={{display:"inline-block",float:"right",height:"auto"}}
                      label={this.props.filtersByOr.find(item => item === "expertise") ? 
                        this.props.translate('Filters-labels.' + ['add-to-select']) : 
                        this.props.translate('Filters-labels.' + ['combine-to-select'])}
                      onClick={() => this.props.setFilterByOr("expertise")}
                      checked={this.props.filtersByOr.find(item => item === "expertise") ? true : false }
                    />
                  </div>
                  <RangeSlider 
                    sliderOption={sliderOption}             
                    value={this.getExpertiseLevel(this.props.expertiseFilter.expertise)}
                    onChangeEnd={this.handleExpertiseFilter.bind(this,"expertise")}
                  />
                  <Select
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    options={expertiseOptions}
                    isClearable={true}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'expertise', expertiseData)}
                    defaultValue={expertiseDefaultValue}
                  />
                </div>
              </div>

            </div>

                    <div className={"formulaire-field select"}>


                        {/*ENGINEERING*/}
                        <div className={"inline"} style={{ width: 'calc(33.33% - 20px)' }}>
                            <div className="input-container">
                                <div>
                                    <span >
                                        <ContainerTranslation id={"content." + ['engineering'] + ".title"} tag={"span"} />
                                    </span>
                                    <SliderCheckbox
                                        style={{ display: "inline-block", float: "right", height: "auto" }}
                                        label={this.props.filtersByOr.find(item => item === "engineering") ?
                                            this.props.translate('Filters-labels.' + ['add-to-select']) :
                                            this.props.translate('Filters-labels.' + ['combine-to-select'])}
                                        onClick={() => this.props.setFilterByOr("engineering")}
                                        checked={this.props.filtersByOr.find(item => item === "engineering") ? true : false}
                                    />
                                </div>
                                <RangeSlider
                                    sliderOption={sliderOption}
                                    value={this.getExpertiseLevel(this.props.expertiseFilter.engineering)}
                                    onChangeEnd={this.handleExpertiseFilter.bind(this, "engineering")}
                                />
                                <Select
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    className={'react-select-container'}
                                    classNamePrefix="react-select"
                                    options={engineeringOptions}
                                    isClearable={true}
                                    formatGroupLabel={formatGroupLabel}
                                    isMulti={true}
                                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                                    onChange={this.selectItem.bind(this, 'engineering', engineeringData)}
                                    defaultValue={engineeringDefaultValue}
                                />
                            </div>
                        </div>


                        {/*TOOLS*/}
                        <div className={"inline"} style={{ width: 'calc(33.33% - 20px)', marginLeft: '25px' }}>
                            <div className="input-container">
                                <div>
                                    <span >
                                        <ContainerTranslation id={"content." + ['tools'] + ".title"} tag={"span"} />
                                    </span>
                                    <SliderCheckbox
                                        style={{ display: "inline-block", float: "right", height: "auto" }}
                                        label={this.props.filtersByOr.find(item => item === "tools") ?
                                            this.props.translate('Filters-labels.' + ['add-to-select']) :
                                            this.props.translate('Filters-labels.' + ['combine-to-select'])}
                                        onClick={() => this.props.setFilterByOr("tools")}
                                        checked={this.props.filtersByOr.find(item => item === "tools") ? true : false}
                                    />
                                </div>
                                <RangeSlider
                                    sliderOption={sliderOption}
                                    value={this.getExpertiseLevel(this.props.expertiseFilter.tools)}
                                    onChangeEnd={this.handleExpertiseFilter.bind(this, "tools")}
                                />
                                <Select
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    className={'react-select-container'}
                                    classNamePrefix="react-select"
                                    options={toolOptions}
                                    isClearable={true}
                                    formatGroupLabel={formatGroupLabel}
                                    isMulti={true}
                                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                                    onChange={this.selectItem.bind(this, 'tools', toolData)}
                                    defaultValue={toolDefaultValue}
                                />
                            </div>
                        </div>



                    </div>

                    {this.user.group !== "aegis" ? null :
                    <div className={"formulaire-field select"}>

                        {/*CERTIFICATION-BODY :: Certification Body*/}

                            <div className={"inline"} style={{ width: 'calc(33.33% - 20px)' }}>
                                <div className="input-container">
                                    <div>
                                        <span >
                                            Certification Body
                                        </span>
                                        <SliderCheckbox
                                            style={{ display: "inline-block", float: "right", height: "auto" }}
                                            label={this.props.filtersByOr.find(item => item === "certification-body") ?
                                                this.props.translate('Filters-labels.' + ['add-to-select']) :
                                                this.props.translate('Filters-labels.' + ['combine-to-select'])}
                                            onClick={() => this.props.setFilterByOr("certification-body")}
                                            checked={this.props.filtersByOr.find(item => item === "certification-body") ? true : false}
                                        />
                                    </div>
                                    <RangeSlider
                                        sliderOption={certificationBodySliderOptions}
                                        value={this.getExpertiseLevel(this.props.expertiseFilter.tools)}
                                        onChangeEnd={this.handleExpertiseFilter.bind(this, "certification-body")}
                                        paddingBottom="55px"
                                    />
                                    <Select
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        className={'react-select-container'}
                                        classNamePrefix="react-select"
                                        options={certificationBodyOptions}
                                        isClearable={true}
                                        formatGroupLabel={formatGroupLabel}
                                        isMulti={true}
                                        placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                                        onChange={this.selectItem.bind(this, 'certification-body', certificationBodyData)}
                                        defaultValue={certificationBodyDefaultValue}
                                    />
                                </div>
                            </div>

                            {/*CERTIFICATION-BODY :: Inspection Body*/}

                            <div className={"inline"} style={{ width: 'calc(33.33% - 20px)', marginLeft: '25px' }}>
                                <div className="input-container">
                                    <div>
                                        <span >
                                            Inspection Body
                                        </span>
                                        <SliderCheckbox
                                            style={{ display: "inline-block", float: "right", height: "auto" }}
                                            label={this.props.filtersByOr.find(item => item === "inspection-body") ?
                                                this.props.translate('Filters-labels.' + ['add-to-select']) :
                                                this.props.translate('Filters-labels.' + ['combine-to-select'])}
                                            onClick={() => this.props.setFilterByOr("inspection-body")}
                                            checked={this.props.filtersByOr.find(item => item === "inspection-body") ? true : false}
                                        />
                                    </div>
                                    <RangeSlider
                                        sliderOption={inspectionBodySliderOptions}
                                        value={this.getExpertiseLevel(this.props.expertiseFilter.tools)}
                                        onChangeEnd={this.handleExpertiseFilter.bind(this, "inspection-body")}
                                        paddingBottom="55px"
                                    />
                                    <Select
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        className={'react-select-container'}
                                        classNamePrefix="react-select"
                                        options={inspectionBodyOptions}
                                        isClearable={true}
                                        formatGroupLabel={formatGroupLabel}
                                        isMulti={true}
                                        placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                                        onChange={this.selectItem.bind(this, 'inspection-body', inspectionBodyData)}
                                        defaultValue={inspectionBodyDefaultValue}
                                    />
                                </div>
                            </div>

                            {/*CERTIFICATION-BODY :: Non-accredited-services*/}

                            <div className={"inline"} style={{ width: 'calc(33.33% - 20px)', marginLeft: '25px' }}>
                                <div className="input-container">
                                    <div>
                                        <span >
                                            Non-accredited-services
                                        </span>
                                        <SliderCheckbox
                                            style={{ display: "inline-block", float: "right", height: "auto" }}
                                            label={this.props.filtersByOr.find(item => item === "non-accredited-services") ?
                                                this.props.translate('Filters-labels.' + ['add-to-select']) :
                                                this.props.translate('Filters-labels.' + ['combine-to-select'])}
                                            onClick={() => this.props.setFilterByOr("non-accredited-services")}
                                            checked={this.props.filtersByOr.find(item => item === "non-accredited-services") ? true : false}
                                        />
                                    </div>
                                    <RangeSlider
                                        sliderOption={nonAccreditedServicesSliderOptions}
                                        value={this.getExpertiseLevel(this.props.expertiseFilter.tools)}
                                        onChangeEnd={this.handleExpertiseFilter.bind(this, "non-accredited-services")}
                                        paddingBottom="55px"
                                    />
                                    <Select
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        className={'react-select-container'}
                                        classNamePrefix="react-select"
                                        options={nonAccreditedServicesOptions}
                                        isClearable={true}
                                        formatGroupLabel={formatGroupLabel}
                                        isMulti={true}
                                        placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                                        onChange={this.selectItem.bind(this, 'non-accredited-services', nonAccreditedServicesData)}
                                        defaultValue={nonAccreditedServicesDefaultValue}
                                    />
                                </div>
                            </div>

                        </div>
                    }

          </div>
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" , marginBottom: '10px', paddingLeft: '10px'}}>
          <div style={{position : "relative"}}>
            <div style={{height : "20px"}}></div>

              <button onClick={() => { this.toggleExtractPopup() ; this.setState({ isButtonDisabled: false }) }} className="primary-btn filling" style={{ width: "156px", height: "48px", marginTop: "20px" }}>
                <div><ContainerTranslation id={['Export'] + "." + ['Extract Button']  } /></div>
              </button>

              {this.state.isExtractPopupOpen?
              <>
                <Popup
                  content={<>
                    <div style={{ textAlign: 'center', margin: '10px'}}><b> <ContainerTranslation id={['Export'] + "." + ['Selection']} /> </b></div>
                    <div style={{ textAlign: 'center', margin: '10px'}}>      
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <button 
                          onClick={() => {this.props.handleExtract('basic'); }}
                          className="primary-btn filling"
                          style={buttonStyle}
                          >
                            <ContainerTranslation id={['Export'] + "." + ['Extract Button']} /> 
                        </button>
                        <button
                          onClick={() => {this.props.handleExtract('lean');}}
                          className="primary-btn filling"
                          style={buttonStyle}
                        >
                          <ContainerTranslation id={['Export'] + "." + ['Extract Button Simple']} /> 
                        </button>
                      </div>
                    </div>
                  </>}
                  handleClose={this.toggleExtractPopup.bind(this)}
                />
              </>
            :<></>}

          </div>
          <div style={{position : "relative"}}>
          <div style={{height : "20px"}}></div>
            <SearchInput
              className="search-input"
              placeholder={this.props.translate('Placeholder-search')}
              id="search-input-consultant"
              onChange={this.props.searchUpdated} />
          </div>
          <div style={{textAlign: 'left', display: 'inline-block', width:'150px', marginLeft:'10px'}}>
              <div>
                <div><ContainerTranslation id={'Validation status'} /></div>
                <Select
                  className={'react-select-container'}
                  classNamePrefix="react-select"
                  options={[
                    {
                      value:'all',
                      label:<ContainerTranslation id={'Validation.All'} />
                    },{
                      value:'validated',
                      label:<ContainerTranslation id={'Validation.Validated'} />
                    },{
                      value:'not validated',
                      label:<ContainerTranslation id={'Validation.Not Validated'} />
                    }
                  ]}
                  defaultValue={{
                    value:'all',
                    label:<ContainerTranslation id={'Validation.All'} />
                  }}
                  formatGroupLabel={formatGroupLabel}
                  isMulti={false}
                  onChange={this.handleValidationFilter.bind(this)}
                />
              </div>
          </div>
          
            
            <div style={{textAlign: 'left', display: 'inline-block', width:'150px', marginLeft:'10px'}}>
              <div>
              <ContainerTranslation id={'Sort By'} />
              <Select
                className={'react-select-container'}
                classNamePrefix="react-select"
                options={[
                  {
                    value:'alphabetic',
                    label:<ContainerTranslation id={'Sort.Alphabetic'} />
                  },{
                    value:'projects',
                    label:<ContainerTranslation id={'Sort.Projects'} />
                  },{
                    value:'years of experience',
                    label: <ContainerTranslation id={'Sort.' + ['Years of experience']} />
                  },{
                    value:'completion',
                    label:<ContainerTranslation id={'Sort.Completion'} />
                  }
                ]}
                defaultValue={{
                  value:'alphabetic',
                  label:<ContainerTranslation id={'Sort.Alphabetic'} />
                }}
                formatGroupLabel={formatGroupLabel}
                isMulti={false}
                onChange={this.handleSortChange.bind(this)}
              />
              </div>
            </div>
          </div>
        </div>
    );
  }
}





export default withLocalize(ConsultantSearch);